import { DetailModel } from '@bsuccess/models/project/detail.model';

export interface State {
    current: DetailModel;
}

export const initialState: State = {
    current: null,
};
